import getMoreResults from "./get_more_results"
import searchResults from "./search_results"
import serviceResults from "./service_results"
import viewToggle from "./view_toggle"

const reducers = {
  getMoreResults,
  searchResults,
  serviceResults,
  viewToggle,
}

export default reducers
